import { Pipe, PipeTransform } from '@angular/core';
import { format, addSeconds } from 'date-fns';

import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(duration: number, fromTime: string): string {
    const [hours, minutes, seconds] = fromTime.toString().split(':');
    const today = new Date();
    const dateTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), +hours, +minutes, +seconds || 0);
    const result = addSeconds(legacyParse(dateTime), duration);

    return `${format(legacyParse(dateTime), convertTokens('HH:mm'))} - ${format(legacyParse(result), convertTokens('HH:mm'))}`;
  }
}
